import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <motion.div
          className="header-brand"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <span className="business-name">NIRUPRINT SOLUTIONS</span>
          <span className="deal-badge">Custom Print Deals!</span>
        </motion.div>

        <nav className="header-nav">
          {['Home', 'Products', 'Services', 'About', 'Contact'].map((item) => (
            <motion.a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="nav-item"
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.98 }}
            >
              {item}
            </motion.a>
          ))}
          <motion.a
            href="#quote"
            className="header-action"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            Get a Quote
          </motion.a>
        </nav>

        <motion.div
          className="menu-toggle"
          onClick={toggleMobileMenu}
          whileHover={{ scale: 1.15 }}
          whileTap={{ scale: 0.85 }}
        >
          {isMobileMenuOpen ? (
            <X className="menu-icon" size={32} />
          ) : (
            <Menu className="menu-icon" size={32} />
          )}
        </motion.div>
      </div>

      <motion.div
        className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}
        initial={{ x: '-100%' }}
        animate={{ x: isMobileMenuOpen ? 0 : '-100%' }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <div className="mobile-nav-content">
          {['Home', 'Products', 'Services', 'About', 'Contact'].map((item) => (
            <motion.a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="mobile-nav-item"
              whileHover={{ x: 5 }}
              onClick={toggleMobileMenu}
            >
              {item}
            </motion.a>
          ))}
          <motion.a
            href="#quote"
            className="mobile-action"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={toggleMobileMenu}
          >
            Get a Quote
          </motion.a>
        </div>
      </motion.div>
    </header>
  );
};

export default Header;